import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from 'reactstrap';
import { Link, useParams } from 'react-router-dom';

function TeamForm({
  submitLabel = 'Update',
  cancelLabel = 'Cancel',
  cancelUrl,
  autoFocus,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  handleSubmit,
}) {
  const { workspaceId, teamId } = useParams();

  const formikAttributes = (fieldName) => ({
    id: fieldName,
    name: fieldName,
    value: values[fieldName],
    onChange: handleChange,
    onBlur: handleBlur,
    invalid: errors[fieldName] && touched[fieldName],
  });

  const formikFeedback = (fieldName) => {
    return errors[fieldName] && touched[fieldName] ? (
      <FormFeedback>{errors[fieldName]}</FormFeedback>
    ) : null;
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4">
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              type="text"
              {...formikAttributes('name')}
              autoFocus={autoFocus}
            />
            {formikFeedback('name')}
          </FormGroup>
        </div>
      </div>
      <div>
        <Button color="primary" type="submit">
          {submitLabel}
        </Button>
        <Link
          color="secondary"
          to={cancelUrl ?? `/w/${workspaceId}/teams/${teamId}/dashboard`}
          className="btn btn-secondary"
        >
          {cancelLabel}
        </Link>
      </div>
    </Form>
  );
}

const FormikTeamForm = withFormik({
  mapPropsToValues: ({ team }) => {
    return {
      name: team?.name || '',
    };
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required('What should we call this team?'),
  }),
  handleSubmit: async (values, bag) => {
    const { setSubmitting, props } = bag;
    const { onSubmit = () => {} } = props;
    setSubmitting(true);
    await onSubmit(values);
    setSubmitting(false);
  },
  displayName: 'TeamForm',
})(TeamForm);

export default FormikTeamForm;
